import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { PropertyDto, PropertyMandateDto } from '@workspace/data-types';
import { DtoChangedDetection } from '@workspace/ng-aura';
import { PropertyMandateDisplayComponent } from '../display/mandate-display.component';
import { PropertyMandateFormComponent } from '../form/mandate-form.component';

@Component({
  selector: 'etxe-property-mandate-edit',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PropertyMandateDisplayComponent,
    PropertyMandateFormComponent,
  ],
  templateUrl: './mandate-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyMandateEditComponent {
  property = input.required<PropertyDto>();
  editMode = input.required<boolean>();
  editable = input<boolean>(true);
  saving = input<boolean>(false);
  isFormValid = signal<boolean>(true);

  editToggled = output<void>();
  cancelToggled = output<void>();
  dtoChanged = output<DtoChangedDetection<PropertyMandateDto>>();
  submitted = output<void>();

  onEdit() {
    this.editToggled.emit();
  }

  onCancel() {
    this.cancelToggled.emit();
  }

  onValidityChanged(isValid: boolean) {
    this.isFormValid.set(isValid);
  }

  onDtoChanged(event: DtoChangedDetection<PropertyMandateDto>) {
    this.dtoChanged.emit(event);
  }

  onSubmit() {
    this.submitted.emit();
  }
}
